import BigNumber from "bignumber.js";
import { Decimal } from "decimal.js";
import { BN } from "bn.js";
import moment from "moment-timezone";
import * as XLSX from 'xlsx';
import { getSymbol } from "@/config/symbol";

moment.tz.setDefault("Asia/Shanghai");
// https://time.is/Hong_Kong#time_zone

export const scanUrl = process.env.REACT_APP_EXPLORE_LINK;

export function updateAddress(addr: string, s: number = 6, e: number = 4) {
  if (!addr) {
    return "";
  }
  const start = addr.substring(0, s);
  const end = addr.substring(addr.length - e, addr.length);
  addr = `${start}...${end}`;

  return addr;
}

export function strDot(str: string, sIndex: number = 6, eIndex: number = 4) {
  if (!str) {
    return "";
  }
  const start = str.substring(0, sIndex);
  const end = str.substring(str.length - eIndex, str.length);
  str = `${start}...${end}`;

  return str;
}

export function getCurrentDate(f: any = "YYYY-MM-DD") {
  return moment().format(f);
}

export function getZeroUnix() {
  return moment().valueOf();
}

export function getUnix(timeStr: any) {
  return moment(timeStr).valueOf();
}

export function getDifTime(endTime: any) {
  const m1: any = Date.now();
  const m2: any = endTime * 1000;
  if (m2 <= m1) {
    return "";
  }
  return moment(m2 - m1).format("HH:mm:ss");
}

export function formatTimeAgo(
  date: any,
  just = "刚刚",
  minuteAgo = "分钟前",
  hourAgo = "小时前"
) {
  const m = moment(date);
  const now = moment();
  const diffInSeconds = now.diff(m, "seconds");
  const diffInMinutes = now.diff(m, "minutes");
  const diffInHours = now.diff(m, "hours");

  if (diffInSeconds < 60) {
    return just;
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} ${minuteAgo}`;
  } else if (diffInHours < 24) {
    return `${diffInHours} ${hourAgo}`;
  }

  // 如果超过24小时，返回原始日期
  return m.format("YYYY-MM-DD HH:mm:ss"); // 或者任何你需要的格式
}

export function getNowTime() {
  return new Promise((resolve) => {
    const xhr = new window.XMLHttpRequest();
    xhr.responseType = "document";
    // 通过get的方式请求当前文件
    xhr.open("head", window.location.origin);
    xhr.send(null);
    // 监听请求状态变化
    xhr.onreadystatechange = function () {
      let time: any = null;
      if (xhr.readyState === 2) {
        // 获取响应头里的时间戳
        time = xhr.getResponseHeader("Date");
        time = time ? new Date(time) : new Date();
        time = Date.parse(time);
        resolve(time);
      }
    };

    setTimeout(function () {
      resolve(new Date());
    }, 2000);
  });
}

export function countTime(end: any, now: any) {
  end = Number(end) * 1000;
  now = Number(now) * 1000;
  //时间差
  let leftTime = end - now;
  // console.log('leftTime', leftTime)
  let d, h, m, s;
  if (leftTime >= 0) {
    d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
    h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
    m = Math.floor((leftTime / 1000 / 60) % 60);
    s = Math.floor((leftTime / 1000) % 60);
  } else {
    d = 0;
    h = 0;
    m = 0;
    s = 0;
  }
  d = `${d}`.length > 1 ? d : `0${d}`;
  h = `${h}`.length > 1 ? h : `0${h}`;
  m = `${m}`.length > 1 ? m : `0${m}`;
  s = `${s}`.length > 1 ? s : `0${s}`;

  return {
    d,
    h,
    m,
    s,
  };
}

export function toThousands(num: number | string): string {
  // 检查 num 是否为无效值或 NaN，并将其转换为 '0'
  if (num === null || num === undefined || isNaN(Number(num))) {
    return "0";
  }

  // 将数字转换为字符串，确保整数和小数部分分开
  const [integer, decimal] = num.toString().split(".");

  // 使用正则表达式来找到小数点前的整数部分，并在每三位数字之间插入逗号
  const formattedInteger = integer.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

  // 如果存在小数部分，将整数部分和小数部分重新组合
  return decimal ? `${formattedInteger}.${decimal}` : formattedInteger;
}

export function queryParam(key: string) {
  let href = window.location.href;
  const m = "?utm_source=tokenpocket";
  if (href.includes(m)) {
    href = href.replace(m, "");
  }
  const url = new URL(href);
  const isHash = href.includes("/#/");
  const splitArr = href.split("?");
  const sp = new URLSearchParams(isHash ? splitArr[1] : url.search);
  return sp.get(key);
}

export function queryAllParam() {
  let href = window.location.href;
  const m = "?utm_source=tokenpocket";
  if (href.includes(m)) {
    href = href.replace(m, "");
  }
  const url = new URL(href);
  const isHash = href.includes("/#/");
  const splitArr = href.split("?");
  const sp = new URLSearchParams(isHash ? splitArr[1] : url.search);
  const arr: any = {};

  sp.forEach(function (value, key, searchParams) {
    // 打印值
    arr[key] = value;
  });
  return arr;
}
export function parseParams(data: any = {}) {
  try {
    const tempArr = [];
    for (let i in data) {
      const key = encodeURIComponent(i);
      const value = encodeURIComponent(data[i]);
      tempArr.push(key + "=" + value);
    }
    const urlParamsStr = tempArr.join("&");
    return urlParamsStr;
  } catch (err) {
    return "";
  }
}

export function sum(x: any, y: any) {
  const a = new BigNumber(x);
  const b = new BigNumber(y);

  return a.plus(b).toFixed();
}

export function minus(x: any, y: any) {

  const a = new BigNumber(x.toString()); // 将输入转换为字符串
  const b = new BigNumber(y.toString()); // 将输入转换为字符串

  return a.minus(b).toString();
}

export function multip(x: any, y: any) {
  const a = new BigNumber(x);
  const b = new BigNumber(y);

  return a.multipliedBy(b).toString();
}

export function dividedBy(x: any, y: any) {
  const a = new BigNumber(x);
  const b = new BigNumber(y);

  return a.dividedBy(b).toString();
}

export function dividedByBNDecimals(x: any, y: any, decimalPlaces: number = 9) {
  const a = new BigNumber(x);
  const b = new BigNumber(y);

  // 进行除法运算并设置小数位数，避免科学计数法显示
  const result = a.dividedBy(b).toFixed(decimalPlaces, BigNumber.ROUND_DOWN);

  return result.toString();
}

export function dividedByDecimal(x: any, y: any) {
  const a = new Decimal(x);
  const b = y;

  return a.dividedBy(b).toString();
}

export function divBN(x: any, y: any) {
  return new BN(x).div(new BN(y)).toString();
}

export function calculateWithPercent(countBalance: bigint, randomPercent: number): bigint {
  console.log('countBalance', countBalance);
  console.log('randomPercent', randomPercent);

  // 1. 将百分比转换为整数以处理精度
  // 例如：12.345% => 12345
  const percentageScale = 1000; // 保留3位小数精度
  const scaledPercent = Math.round(randomPercent * percentageScale);

  // 2. 先进行整数乘法
  const scaledResult = countBalance * BigInt(scaledPercent);

  // 3. 除以比例因子(100 * percentageScale)以得到最终结果
  // 100是因为要将百分比转换为小数
  const finalResult = scaledResult / BigInt(percentageScale);

  return finalResult;
}

// 计算solana大数
export function convertLamportsToSol(
  lamports: any,
  decimals: number = 9
): string {
  const lamportsPerSol = new BigNumber(10).pow(decimals); // 1 SOL = 1e9 Lamports
  const amountInSol = new BigNumber(lamports).dividedBy(lamportsPerSol);

  // 使用 toFixed 来保持特定的小数位数精度
  return amountInSol.toString();
}

export function getStartTime() {
  const sTime = Date.now() - 24 * 60 * 60 * 1000;
  return moment(sTime).format();
}

export function getNowDate() {
  const sTime = Date.now();
  return moment(sTime).format("YYYY-MM-DD");
}

export function getUtcTime(sTime: any, f: any = "YYYY-MM-DD HH:mm:ss") {
  if (!sTime) {
    return "";
  }
  return moment(sTime).format(f);
}

export function getDurationTime(seconds: any) {
  //时间差
  let leftTime: any = seconds * 1000;
  // console.log('leftTime', leftTime)
  let d, h, m, s;
  if (leftTime >= 0) {
    d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
    h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
    m = Math.floor((leftTime / 1000 / 60) % 60);
    s = Math.floor((leftTime / 1000) % 60);
  } else {
    d = 0;
    h = 0;
    m = 0;
    s = 0;
  }
  d = `${d}`.length > 1 ? d : `0${d}`;
  h = `${h}`.length > 1 ? h : `0${h}`;
  m = `${m}`.length > 1 ? m : `0${m}`;
  s = `${s}`.length > 1 ? s : `0${s}`;

  return {
    d,
    h,
    m,
    s,
  };
}

export function filterNotNumber(item: any, digits: any = 2) {
  if (!item) {
    return item;
  }
  item = `${item}`.replace(/[^\d.]/g, "");
  const index = item.indexOf(".");
  if (index > -1) {
    let start = item.substring(0, index);
    let str = item.substring(index, item.length);
    str = str.replace(/[.]/gi, "");
    str = str.substring(0, digits);
    return `${start}.${str}`;
  }

  return item;
}

export function numberDigits(item: any, digits: any = 2) {
  if (!item) {
    return item;
  }
  item = `${item}`.replace(/[^\d.]/g, "");
  const index = item.indexOf(".");
  if (index > -1) {
    let start = item.substring(0, index);
    let str = item.substring(index, item.length);
    str = str.replace(/[.]/gi, "");
    str = str.substring(0, digits);
    return `${start}.${str}`;
  }

  return item;
}

export function numberWithCommas(item: any, digits: number = 2) {
  if (!item && item !== 0) {
    return item;
  }

  // 将输入转换为字符串并移除非数字和非小数点字符
  let numStr = item.toString().replace(/[^\d.-]/g, "");

  // 分割整数部分和小数部分
  let parts = numStr.split(".");
  let integerPart = parts[0];
  let decimalPart = parts[1] || "";

  // 对整数部分添加千分位分隔符
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // 限制小数部分的长度
  decimalPart = decimalPart.substring(0, digits);

  // 合并整数部分和处理后的小数部分
  numStr = integerPart + (decimalPart ? "." + decimalPart : "");

  return numStr;
}

export function str2hex(str: any) {
  if (str === "") {
    return "";
  }
  var arr = [];
  arr.push("0x");
  for (var i = 0; i < str.length; i++) {
    arr.push(str.charCodeAt(i).toString(16));
  }
  return arr.join("");
}

export function getAddrEq(addr1: any, addr2: any) {
  return `${addr1}`.toLocaleLowerCase() === `${addr2}`.toLocaleLowerCase();
}

export function toNumberStr(num: any) {
  num = !num ? 0 : num;
  const m: any = Number(num)
    .toExponential()
    .match(/\d(?:\.(\d*))?e([+-]\d+)/);
  return Number(num).toFixed(Math.max(0, (m[1] || "").length - m[2]));
}

export function getNextDividendDay() {
  const date = getNowDate();
  const arr = date.split("-");
  const m = arr[1];
  const d = arr[2];
  const mNum = Number(m);
  const dNum = Number(d);

  if (dNum > 20) {
    if (mNum == 12) {
      return "01-20";
    } else {
      const t: any = mNum + 1;
      const s = t > 9 ? `${t}` : `0${t}`;
      return `${s}-20`;
    }
  } else {
    return `${m}-20`;
  }
}

export function getLastFriday() {
  return moment().day(-2).format("YYYY-MM-DD");
}

export function formatMoney(num: String | Number, wei = 8) {
  num = parseFloat(Number(num).toFixed(wei));
  let [integer, decimal]: any = `${num}`.split(".");
  integer = integer.replace(/\d(?=(\d{3})+$)/g, "$&,"); // 正则先行断言
  return `${integer}${decimal ? "." + decimal : ""}`;
}

export function getScanUrl(addr: any = "", type: any = 0) {
  if (type === 0) {
    return `${scanUrl}/address/${addr}`;
  }
  return scanUrl;
}

export const WEEK = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

/* 获取时间段内属于星期一(*)的日期们
 * begin: 开始时间
 * end：结束时间
 */
export function getWeek(begin: any, end: any) {
  let dateArr = [];
  let stimeArr = begin.split("-"); //=>["2018", "01", "01"]
  let etimeArr = end.split("-"); //=>["2018", "01", "30"]
  let stoday = new Date(`${begin} 00:00:00`);
  // stoday.setUTCFullYear(stimeArr[0], stimeArr[1]-1, stimeArr[2]);
  let etoday = new Date(`${end} 23:59:59`);
  // etoday.setUTCFullYear(etimeArr[0], etimeArr[1]-1, etimeArr[2]);

  let unixDb = stoday.getTime(); //开始时间的毫秒数
  let unixDe = etoday.getTime(); //结束时间的毫秒数

  for (let k = unixDb; k <= unixDe;) {
    let needJudgeDate = msToDate(parseInt(`${k}`)).withoutTime;
    //不加这个if判断直接push的话就是已知时间段内的所有日期
    //  if (new Date(needJudgeDate).getDay() === weekNum) {
    //      dateArr.push(needJudgeDate);
    //  }
    const time: any = new Date(needJudgeDate);
    const tmp = needJudgeDate.split("-");
    const index: number = new Date(needJudgeDate).getDay();
    dateArr.push({
      day: tmp[tmp.length - 1],
      label: WEEK[index],
      index: index,
      date: needJudgeDate,
      unix: Date.parse(time),
    });
    k = k + 24 * 60 * 60 * 1000;
  }
  return dateArr;
}

//根据毫秒数获取日期
export function msToDate(msec: any) {
  let datetime = new Date(msec);
  let year = datetime.getFullYear();
  let month = datetime.getMonth();
  let date = datetime.getDate();
  let hour = datetime.getHours();
  let minute = datetime.getMinutes();
  let second = datetime.getSeconds();

  let result1 =
    year +
    "-" +
    (month + 1 >= 10 ? month + 1 : "0" + (month + 1)) +
    "-" +
    (date + 1 < 10 ? "0" + date : date) +
    " " +
    (hour + 1 < 10 ? "0" + hour : hour) +
    ":" +
    (minute + 1 < 10 ? "0" + minute : minute) +
    ":" +
    (second + 1 < 10 ? "0" + second : second);

  let result2 =
    year +
    "-" +
    (month + 1 >= 10 ? month + 1 : "0" + (month + 1)) +
    "-" +
    (date + 1 < 11 ? "0" + date : date);

  let result = {
    hasTime: result1,
    withoutTime: result2,
  };

  return result;
}

export function getHour(str: any = "") {
  return str.split(" ")[1] || "";
}

export function convertToHexString(dataObject: Object): any {
  // 将JSON对象转换为JSON字符串
  const jsonString = JSON.stringify(dataObject);

  // 将JSON字符串转换为十六进制字符串
  const hexString = Buffer.from(`data:,${jsonString}`, "utf-8").toString("hex");

  return `0x${hexString}`;
}

export function getJsonDataStr(obj: Object) {
  const jsonString = JSON.stringify(obj);
  return `data:,${jsonString}`;
}

export function fillToEightDigits(number: any) {
  // 将数字转换为字符串
  let numberString = String(number);

  // 计算需要填充的零的个数
  let zeroCount = 8 - numberString.length;

  // 如果需要填充零，则在数字前添加相应个数的零
  if (zeroCount > 0) {
    numberString = "0".repeat(zeroCount) + numberString;
  }

  return numberString;
}

// 检查一个值是否为 undefined、null、空字符串(""), 或对数字变量是否为非数字值。
export function isValid(value: any) {
  return value == null || value === "" || typeof value === "undefined";
}

export function splitArrayIntoChunks(array: [], chunkSize: number = 1) {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    const chunk = array.slice(i, i + chunkSize);
    result.push(chunk);
  }
  return result;
}

export function flattenArray<T>(multiDimensionalArray: T[][]): T[] {
  // 将多维数组扁平化为一维数组
  return multiDimensionalArray.reduce(
    (accumulator, currentValue) => accumulator.concat(currentValue),
    []
  );
}

interface Item {
  amount: number;
}

export function findItemsWithEightDecimalPlaces(array: Item[]): Item[] {
  return array.filter((item) => {
    const amountStr: string = item.amount.toString();
    const decimalPart: string = amountStr.split(".")[1] || ""; // 获取小数部分
    return decimalPart.length >= 8;
  });
}

export function chunkArray<T>(array: T[], chunkSize: number): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
}

type PriceMap = Record<string, number>;

export const calculateTotalRecycleValue = (
  addresses: string[],
  priceMap: PriceMap
): number => {
  return addresses.reduce((total, address) => {
    const price = priceMap[address] || 0; // 如果地址不存在于映射中，回收价格默认为0
    return total + price;
  }, 0);
};

export function getRandomNumberInRange(
  start: number,
  end: number,
  decimalPlaces: number
): number {
  if (start > end) {
    throw new Error("开始数必须小于等于结束数");
  }
  if (decimalPlaces < 0) {
    throw new Error("小数位数必须是非负数");
  }

  const random = Math.random() * (end - start) + start;
  return parseFloat(random.toFixed(decimalPlaces));
}

export function getRandomNumberInRangeNew(
  start: number,
  end: number,
  decimalPlaces: number
): number {
  if (start > end) {
    throw new Error("开始数必须小于等于结束数");
  }
  if (decimalPlaces < 0) {
    throw new Error("小数位数必须是非负数");
  }

  const random = Math.random() * (end - start) + start;
  const factor = Math.pow(10, decimalPlaces);
  return Math.floor(random * factor) / factor;
}

export const openNewTab = (path: any = "", language: any = "") => {
  const currentLanguage = language;
  const baseURL = window.location.origin;
  const url = `${baseURL}/${currentLanguage}${path}`;
  window.open(url, "_blank");
};

export function getRandomAmountInRange(start: any, end: any) {
  const a = new BigNumber(start);
  const b = new BigNumber(end);

  if (a.isEqualTo(b)) {
    return a.toFixed(6);
  }

  if (a.isGreaterThanOrEqualTo(b)) {
    throw new Error("开始数必须小于结束数");
  }

  const range = b.minus(a);
  const randomFactor = new BigNumber(Math.random());
  const randomAmount = range.multipliedBy(randomFactor).plus(a);

  return randomAmount.toFixed(6);
}

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export function isValidNumber(value: string): boolean {
  const num = Number(value);
  return !isNaN(num) && isFinite(num);
}

export function getRandomAmount(
  randomAmountStart: number,
  randomAmountEnd: number,
  decimalPlaces: number = 3
): number {
  // 生成 randomAmountStart 和 randomAmountEnd 之间的随机浮点数
  const randomValue =
    Math.random() * (randomAmountEnd - randomAmountStart) + randomAmountStart;
  const factor = Math.pow(10, decimalPlaces);
  return Math.floor(randomValue * factor) / factor;
  // // 检查传入的两个数字是否都是整数
  // const isStartInteger = Number.isInteger(randomAmountStart);
  // const isEndInteger = Number.isInteger(randomAmountEnd);

  // if (isStartInteger && isEndInteger) {
  //   // 如果两个参数都是整数，返回随机整数
  //   return Math.floor(randomValue);
  // } else {
  // 否则保留指定小数位数
  // return parseFloat(randomValue.toFixed(decimalPlaces));
  // }
}

export function formatNumber(item: any, digits: any = 2) {
  const tmp = filterNotNumber(item, digits);

  return toThousands(tmp);
}

// 字符串拆分求和
export function sumAmounts(amounts: string): number {
  // 将字符串按换行符拆分为数组
  const amountArray = amounts.split("\n");

  // 将数组中的每个元素转换为数字并求和
  const total = amountArray.reduce((acc, amount) => {
    const num = parseFloat(amount); // 将字符串转换为数字
    return acc + (isNaN(num) ? 0 : num); // 如果转换失败返回0，确保安全
  }, 0);

  return total;
}

export function getRandomPercent(
  randomPercentStart: number,
  randomPercentEnd: number
): number {
  // 如果两个值相等，返回其中一个（除以100得到百分比）
  if (randomPercentStart === randomPercentEnd) {
    return randomPercentStart / 100;
  }

  // 否则生成 [randomPercentStart, randomPercentEnd] 之间的随机数并除以100得到百分比
  return (
    (Math.random() * (randomPercentEnd - randomPercentStart) +
      randomPercentStart) /
    100
  );
}

/**
 * 将形如 "1.2345e-7" 的字符串转成 "0.00000012345"
 * 避免使用 toFixed 造成精度损失
 */
function expandExponential(numStr: string): string {
  // 检查是否有负号
  let negative = false;
  if (numStr.startsWith('-')) {
    negative = true;
    numStr = numStr.slice(1);
  }

  // 如果不包含 'e'，直接返回
  if (!numStr.toLowerCase().includes('e')) {
    return (negative ? '-' : '') + numStr;
  }

  // 拆分出底数(base) 和 指数(exponent)
  const [base, expStr] = numStr.toLowerCase().split('e');
  let exponent = parseInt(expStr, 10);

  // 再拆分 base 的整数和小数部分
  let [intPart, fracPart] = base.split('.');
  if (!intPart) intPart = '0';
  if (!fracPart) fracPart = '';

  // 根据 exponent 大小，移动小数点位置
  if (exponent > 0) {
    // e 为正，往右移动小数点
    while (exponent > 0) {
      if (fracPart.length > 0) {
        intPart += fracPart[0];
        fracPart = fracPart.slice(1);
      } else {
        // 小数部分已经空了，就补 0
        intPart += '0';
      }
      --exponent;
    }
    // 合并整数和剩余小数
    numStr = intPart + (fracPart.length > 0 ? '.' + fracPart : '');
  } else {
    // e 为负，往左移动小数点
    let absExp = Math.abs(exponent);
    while (absExp > 0) {
      // 如果整数部分还有数字，就从末尾搬到小数部分开头
      if (intPart.length > 0) {
        fracPart = intPart[intPart.length - 1] + fracPart;
        intPart = intPart.slice(0, -1);
      } else {
        // 整数部分已经空了，就在小数前面补 0
        fracPart = '0' + fracPart;
      }
      --absExp;
    }
    // 合并结果，确保整数部分至少是 "0"
    numStr = (intPart.length === 0 ? '0' : intPart) + '.' + fracPart;
  }

  return (negative ? '-' : '') + numStr;
}

export function formatDecimalWithZeros(
  num: number | string,
  precision: number = 4,
  decimalPlaces: number = 7
): string {
  // 1. 先转字符串（可能是 "1.2345e-7"）
  let numStr = num?.toString() ?? num;

  // 2. 如果是科学计数法，就手动展开
  if (numStr.toLowerCase().includes('e')) {
    numStr = expandExponential(numStr);
    // 此时 numStr 可能类似 "0.00000012345"
  }

  // 3. 转成数字做一下基本判断
  const numericVal = parseFloat(numStr);

  // 3.1 如果大于等于 0.0001，就走普通逻辑
  if (numericVal >= 0.0001) {
    // 先固定 decimalPlaces 位，再 parseFloat 去掉尾随 0
    // 注意：这里使用 toFixed 只做“截断/保留”用途，不再解决科学计数问题
    return parseFloat(numericVal.toFixed(decimalPlaces)).toString();
  }

  // 4. 处理前导零逻辑
  //    形如 /^0\.(0+)(\d*)$/
  const match = numStr.match(/^0\.(0+)(\d*)$/);
  if (match) {
    const leadingZeros = match[1].length;  // 小数点后连续 0 的个数
    let significantPart = match[2] || '';  // 有效数字部分

    // 如果前导零数 >= 4，使用 0.0{6}xxxx 格式
    if (leadingZeros >= 4) {
      // 如果有效数字长度超过 precision，则四舍五入
      // 例如 0.00000012345 -> leadingZeros=6, significantPart="12345"
      // parseFloat("0.12345") => 0.12345
      // × 10^4 => 1234.5 -> Math.round -> 1235 => "1235"
      if (significantPart.length > precision) {
        const rounded = Math.round(
          parseFloat(`0.${significantPart}`) * Math.pow(10, precision)
        );
        significantPart = rounded.toString();
      }
      return `0.0{${leadingZeros}}${significantPart}`;
    }
  }

  // 5. 如果不符合前导零 >= 4 的规则，就按普通小数处理
  return parseFloat(numericVal.toFixed(decimalPlaces)).toString();
}

export function exportExcel(list: any = [], fileName: string) {
  const ws = XLSX.utils.json_to_sheet([
    ...list
  ]);

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "slerfTools");
  XLSX.writeFile(wb, `${getSymbol()}_${fileName}_${getCurrentDate("YYYYMMDD")}_${getCurrentDate('HHmmss')}.xlsx`);
}

/**
 * @param {Array} list - 要导出的数组
 * @param {string} fileName - 导出的文件名，如 "list.csv"
 */
export function exportToCSV(list, fileName: string) {
  if (!list || !list.length) {
    console.error("No data to export.");
    return;
  }

  // 获取表头（即对象的 key）
  const header = Object.keys(list[0]);

  // CSV 的第一行是表头，后续每行为一条数据
  const csvRows = [];
  csvRows.push(header.join(",")); // 表头行

  list.forEach((item) => {
    // 为了避免字段内容里包含逗号或换行，对数据做转义/加引号处理
    const row = header.map((fieldName) => {
      const val = item[fieldName] ?? "";
      // 将双引号替换为两个双引号，以防止CSV解析问题
      return `"${String(val).replace(/"/g, '""')}"`;
    });
    csvRows.push(row.join(","));
  });

  // 拼成最终的 CSV 文本
  const csvContent = csvRows.join("\r\n");

  // 利用 Blob 创建下载链接
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  // 创建隐藏的 <a> 标签，实现下载
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${getSymbol()}_${fileName}_${getCurrentDate("YYYYMMDD")}_${getCurrentDate('HHmmss')}`);
  document.body.appendChild(link);
  link.click();
  // 下载完成后移除元素
  document.body.removeChild(link);
}

export function exportToText(data, fileName: string) {
  if (!data || !data.length) {
    console.error("No data to export.");
    return;
  }

  const header = Object.keys(data[0]).join(",");
  const lines = [header];

  data.forEach((item) => {
    const row = Object.values(item).join(",");
    lines.push(row);
  });

  const content = lines.join("\n");

  const blob = new Blob([content], { type: "text/plain;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${getSymbol()}_${fileName}_${getCurrentDate("YYYYMMDD")}_${getCurrentDate('HHmmss')}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function exportToJSON(data, fileName: string) {
  if (!data) {
    console.error("No data to export.");
    return;
  }

  // 第三个参数 2 表示 json 缩进两个空格，便于阅读
  const jsonStr = JSON.stringify(data, null, 2);

  const blob = new Blob([jsonStr], { type: "application/json" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${getSymbol()}_${fileName}_${getCurrentDate("YYYYMMDD")}_${getCurrentDate('HHmmss')}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
